// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-key-tip-FNDXx_{width:200px!important}.modal-key-tip-FNDXx_ ul{padding-left:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-key-tip": `modal-key-tip-FNDXx_`,
	"modalKeyTip": `modal-key-tip-FNDXx_`
};
export default ___CSS_LOADER_EXPORT___;
